module.exports = __webpack_public_path__ + "static/media/dummy.fe82902e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dummy.jpg
// module id = 6012
// module chunks = 1